export default from './member-list';



// WEBPACK FOOTER //
// ./app/components/member-list/index.js